<template>
    <div style="height: 100%">
        <transition name="fade" mode="out-in">
            <component :is="layout">
                <router-view></router-view>
            </component>
        </transition>
    </div>
</template>

<script>
  const default_layout = 'guest';

  export default {
    name: 'Master',
    props: {
      references: String
    },
    computed: {
      layout () {
        return (this.$route.meta.layout || default_layout) + '-layout';
      }
    },
    created() {
      if (this.references) {
        this.$root.globalRef = JSON.parse(this.references); // comes from prop
      }
    }
  }
</script>

<style scoped>

</style>
